import React, { useEffect } from "react";
// @ts-ignore
import { SCR_APP_URLS } from "shared/consts";
import store from "src/store";
import { useLocation } from "../use-history";

export default function AppContainer(props) {
  const location = useLocation();

  useEffect(() => { checkIsAdmin(); checkEngagementManagerAccess(); }, []);

  //This is for pre-fetching simulation metadata
  useEffect(() => {
    if (location.pathname.match(SCR_APP_URLS.library)) {
      fetchSimulationMetadata();
    }
    fetchSelectedReviewData();
  }, [location]);

  //This is for pre-fetching simulation maindata or step data
  useEffect(() => {
    if (qs().review_id) {
      fetchSimulationMaindata();
    }
  }, [store.simulationMetadataLoading, store.allSimulations]);

  //This is for pre-fetching default simulation data
  useEffect(() => {
    if (store.selectedReviewData['defaultStepSimulationId']) {
      store.fetchDefaultStepSimulationData();
    } else {
      store.defaultSimulationData = {};
      store.updateStore();
    }
  }, [store.selectedReviewData]);

  const fetchSimulationMetadata = () => {
    store.fetchSimulationListMetadata();
  }

  const fetchSimulationMaindata = () => {
    store.fetchSimulationMaindata();
  }

  const fetchSelectedReviewData = async () => {
    if (qs().review_id) {
      await store.fetchSelectedReviewData();
    } else {
      store.selectedReviewData = {};
    }
    store.updateStore();
  }

  const checkIsAdmin = async () => {
    await store.checkIsAdmin();
  }

  const checkEngagementManagerAccess = async () => {
    await store.checkEngagementManagerAccess();
}

  store.useRerenderIfChange(() => [
    store.simulationMetadataLoading,
    store.allSimulations.length,
    store.selectedReviewData
  ]);

  return (
    <>
      {props.children}
    </>
  )
}

export function qs() {
  return require('qs').parse(location.search.slice(1))
}
